import axios from 'axios';
import moment from 'moment';
import momentUS from 'moment-timezone';
import { EBAY_REASON_RETURN_TROUBLE, FIELD_LABELS, FIELD_LIMITS, STATUS_ITEM_MANAGEMENT, TAddress } from './constants';

export const toCamelCase = (str) => {
  // Split the string into words
  let words = str.split(/[\s-_]+/);

  // Convert the first word to lowercase
  let camelCaseStr = words[0].toLowerCase();

  // Process each subsequent word
  for (let i = 1; i < words.length; i++) {
    let word = words[i];
    camelCaseStr += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  return camelCaseStr;
};

export const getLinkCancelLationNavigate = (returnId: string) =>
  `https://www.ebay.com/rtn/Return/ReturnsDetail?returnId=${returnId}`;

export const getLinkUserEbayNavigate = (userEbayId: string, type: 'str' | 'usr') =>
  `https://www.ebay.com/${type}/${userEbayId}`;

export const getLinkItemEbayNavigate = (itemId: string) => `https://www.ebay.com/itm/${itemId}`;

//YYYY/MM/DD
export const formatDate = (time: Date | string) => (time ? moment(time).format('YYYY/MM/DD') : '');

export const AmericaTimezone = 'America/Los_Angeles';
export const formatDateUS = (time: Date | string) =>
  time ? momentUS(time).tz(AmericaTimezone).format('YYYY/MM/DD') : '';

//YYYY年MM月DD日
export const formatDateJP = (isoString: string) => {
  const formattedDate = moment(isoString).format('YYYY年MM月DD日');
  return formattedDate;
};

export const formatCurrency = (number: number, minimumFractionDigits = 0, maximumFractionDigits = 2) =>
  new Intl.NumberFormat('en-US', { minimumFractionDigits, maximumFractionDigits }).format(number || 0);

export const countDecimalPlaces = (num: number) => {
  if (!num) return 0;
  const numStr = num.toString();
  const decimalIndex = numStr.indexOf('.');
  if (decimalIndex === -1) {
    return 0;
  }
  return numStr.length - decimalIndex - 1;
};

export const handleViewStatusItem = (status: string): string => {
  switch (status) {
    case STATUS_ITEM_MANAGEMENT.NOT_DELIVERED:
      return 'バイヤー発送前';
    case STATUS_ITEM_MANAGEMENT.NOT_SHIPPED:
      return 'バイヤー発送前';
    case STATUS_ITEM_MANAGEMENT.IN_TRANSIT:
      return '返送中';
    case STATUS_ITEM_MANAGEMENT.DELIVERED:
    case STATUS_ITEM_MANAGEMENT.WAITING_STORAGE:
    case STATUS_ITEM_MANAGEMENT.WAITING_UPLOAD_IMAGE_VIDEO:
      return '到着済';
    // case STATUS_ITEM_MANAGEMENT.IN_STORAGE:
    //   return '保管中';
    case STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING:
      return '新規発送依頼';
    case STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING_DONE:
      return '発送準備完了';
    case STATUS_ITEM_MANAGEMENT.SHIPPED_BACK:
      // TODO: phase 2 shipback cần check lại
      return '発送';
    case STATUS_ITEM_MANAGEMENT.DISPOSED:
      return '廃棄済';
    case STATUS_ITEM_MANAGEMENT.CANCELED:
      return 'キャンセル済';
    case STATUS_ITEM_MANAGEMENT.NEW_DISPOSAL_REQUEST:
      return '廃棄依頼';
    case STATUS_ITEM_MANAGEMENT.SHIPPED:
    case STATUS_ITEM_MANAGEMENT.SHIPPED_TO_BUYER:
      return '発送済';
    case STATUS_ITEM_MANAGEMENT.PRICE_INPUTED:
      return '廃棄処理待ち';
    case STATUS_ITEM_MANAGEMENT.IN_STORAGE_NOT_REFUNDED:
      return '検品完了';
    case STATUS_ITEM_MANAGEMENT.INSTORAGE_REFUNDED:
      return '保管中';
    // case STATUS_ITEM_MANAGEMENT.SHIP_TO_BUYER_OPEN:
    //   return '新規発送依頼';
    // case STATUS_ITEM_MANAGEMENT.SHIP_TO_BUYER_PREPARING_DONE:
    //   return '発送準備完了';
    case STATUS_ITEM_MANAGEMENT.SHIP_TO_BUYER_SHIPPED:
      return 'バイヤーへ発送済';
    case STATUS_ITEM_MANAGEMENT.SHIP_TO_BUYER_DELIVERED:
      return 'バイヤーへ到着済';
    // case STATUS_ITEM_MANAGEMENT.DIPOSAL_OPEN:
    //   return '廃棄依頼';
    // case STATUS_ITEM_MANAGEMENT.DISPOSAL_WAIT:
    //   return '廃棄処理待ち';
    // case STATUS_ITEM_MANAGEMENT.DISPOSAL_DONE:
    //   return '廃棄済';
    case STATUS_ITEM_MANAGEMENT.STORAGE_REQUEST_CANCELED:
      return 'キャンセル済';
    case STATUS_ITEM_MANAGEMENT.TEMPORARY_CANCELED:
      return '暫定キャンセル';
    default:
      return '';
  }
};

export const fetchFileContent = async (url) => {
  try {
    const response = await axios.get(url, {
      responseType: 'arraybuffer', // Important for handling binary data
    });
    return {
      filename: url.substring(url.lastIndexOf('/') + 1), // Extract filename from URL
      content: response.data,
    };
  } catch (error) {
    console.error('Error fetching file:', error);
    return null;
  }
};

export const getLinkOrderEbayNavigate = (orderId: string) => `https://www.ebay.com/mesh/ord/details?orderid=${orderId}`;

export const unescapeHtml = (inputString: string): string => {
  const htmlEntities: { [key: string]: string } = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
  };

  return inputString?.replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/g, (match) => htmlEntities[match]);
};

export const unSubscriptionInformation = () => {
  const before25: boolean = moment().get('date') < 25 ? true : false;
  return {
    nextPaymentAt: before25
      ? moment().date(25).format('YYYY/MM/DD')
      : moment().date(25).add(1, 'month').format('YYYY/MM/DD'),
    endPlanAt: before25
      ? moment().endOf('month').format('YYYY/MM/DD')
      : moment().add(1, 'month').endOf('month').format('YYYY/MM/DD'),
    joinAgainAt: before25
      ? moment().add(2, 'month').startOf('month').format('YYYY/MM/DD')
      : moment().add(3, 'month').startOf('month').format('YYYY/MM/DD'),
  };
};

export const sentToSlack = async (msg: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/sent-to-slack`,
    {
      message: msg,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};
export const resizeImageItemEbay = (urlImage: string, size: number = 150) => {
  if (!urlImage) return urlImage;
  const split = urlImage.split('/');
  return (split[split.length - 1] = `s-l${size}.jpg`), split.join('/');
};

export const calculateVolumnWeight = (height: number, width: number, length: number) => {
  return (height * width * length) / 5000;
};

export const mappingReason = (reason: string) => {
  const EBAY_RETURN_REASONS = {
    [EBAY_REASON_RETURN_TROUBLE.ARRIVED_DAMAGED]: 'Arrived damaged',
    [EBAY_REASON_RETURN_TROUBLE.DEFECTIVE_ITEM]: 'Doesn’t work or defective',
    [EBAY_REASON_RETURN_TROUBLE.DIFFERENT_FROM_LISTING]: 'Doesn’t match description or photos',
    [EBAY_REASON_RETURN_TROUBLE.FAKE_OR_COUNTERFEIT]: 'Doesn’t seem authentic',
    [EBAY_REASON_RETURN_TROUBLE.FOUND_BETTER_PRICE]: 'Found better price',
    [EBAY_REASON_RETURN_TROUBLE.MISSING_PARTS]: 'Missing parts or accessories',
    [EBAY_REASON_RETURN_TROUBLE.NO_LONGER_NEED_ITEM]: 'Changed mind',
    [EBAY_REASON_RETURN_TROUBLE.NOT_AS_DESCRIBED]: 'Doesn’t match description or photos',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_ACCIDENTALLY]: 'Ordered by mistake',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_DIFFERENT_ITEM]: 'Wrong item sent',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_WRONG_ITEM]: 'Didn’t like item',
    [EBAY_REASON_RETURN_TROUBLE.WRONG_SIZE]: 'Doesn’t fit',
  };

  return EBAY_RETURN_REASONS[reason] || reason;
};

export const containsInvalidCharacters = (address: string): boolean => {
  const invalidCharRegex = /[^a-zA-Z0-9\s+,-.;:()_"'\[\]\\~]/;
  return invalidCharRegex.test(address);
};

export const formatDateFit = (dateStr) => {
  if (!dateStr) return '';
  let fixedDateStr = dateStr;

  if (/^\d{4}\/\d{2}$/.test(dateStr)) {
    fixedDateStr = dateStr.replace('/', '-') + '-01';
  } else if (/^\d{4}年\d{2}月$/.test(dateStr)) {
    fixedDateStr = dateStr.replace('年', '-').replace('月', '') + '-01';
  }

  return moment(fixedDateStr).format('YYYY年MM月');
};

export function formatUsd(value: number | undefined | null): string {
  return `${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0)}`;
}

type FieldErr = { name: (string | number)[]; errors: string[] };

export function validateMaxLengths(values) {
  const messages: string[] = [];
  const fieldErrors: FieldErr[] = [];

  (Object.keys(FIELD_LIMITS) as Array<keyof typeof FIELD_LIMITS>).forEach((key) => {
    const limit = FIELD_LIMITS[key];
    const val = (values[key] ?? '') as string;
    if (val && val.length > limit) {
      const msg = `${FIELD_LABELS[key]}は${limit}文字以内にしてください`;
      messages.push(msg);
      fieldErrors.push({ name: [key], errors: [msg] });
    }
  });

  return { messages, fieldErrors };
}
